import * as signalR from '@microsoft/signalr';

/* eslint no-param-reassign: "off", no-console: "off" */
const notificationStore = {
  state: {
    notifications: [],
    notificationsLoading: true,
    notificationStream: null
  },
  mutations: {
    setNotificationStream(state, payload) {
      state.notificationStream = payload;
    },
    fetchNotifications(state, payload) {
      state.notifications = payload;
      state.notificationsLoading = false;
    },
    addNotification(state, payload) {
      state.notifications.unshift(payload);
    },
    markAllAsRead(state, payload) {
      const localUnread = state.notifications.filter(n => n.isRead === false).length;
      if (payload == localUnread) {
        state.notifications.forEach(n => {
          n.isRead = true;
        });
      }
    },
    clearNotifications(state) {
      state.notifications = [];
    }
  },
  actions: {
    listenForNotifications({ commit, rootState, dispatch }) {
      // define the connection first
      const streamConnection = new signalR.HubConnectionBuilder()
        .withUrl(`${rootState.appConfig.liveUrl}/notifications?access_token=${window.$auth.accessToken}`)
        .withAutomaticReconnect()
        .build();
      streamConnection.on('Notification', (notification) => {
        commit('addNotification', notification);
        console.log("name : ", JSON.stringify(notification.name));
        // if syncremote notification arrived
        if ((notification.name === 'SyncRemote' || notification.name === 'SyncTerminal') && (notification.type == 'Success' || notification.type == 'Error' || notification.type == 'PartialSuccess')) {
          commit('remoteSyncInProgress', { id: notification.metadata.entityId, isSyncInProgress: false });
          dispatch('fetchProviderNetworkRichState', { id: notification.metadata.entityId });
          dispatch('fetchTerminalHubState', { id: notification.metadata.entityId });
        }
      });
      streamConnection.start({ withCredentials: false }).then(() => {
        commit('setNotificationStream', streamConnection);
      }).catch((err) => {
        console.error(err);
      });
    },
    // eslint-disable-next-line consistent-return
    async fetchNotifications({ state, commit }) {
      try {
        const res = await fetch('/v1/notifications');
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        commit('fetchNotifications', data);
        return data;
      } catch (ex) {
        console.error(`Error fetching notifications: ${ex}`);
        state.notificationsLoading = false;
        return false;
      }
    },
    async clearNotifications({ commit }) {
      try {
        const res = await fetch('/v1/notifications', {
          method: 'DELETE'
        });
        if (!res.ok) throw new Error(await res.text());
        commit('clearNotifications');
        return true;
      } catch (ex) {
        console.error(ex);
        return false;
      }
    },
    async markAllAsRead({ state, commit }) {
      // get all unread notifications
      const unreadNotifications = state.notifications.filter(n => n.isRead === false);
      // send their ids to the service to mark as read
      try {
        const res = await fetch('/v1/notifications', {
          body: JSON.stringify(unreadNotifications.map(n => n.id)),
          method: 'PUT',
          headers: new Headers({ 'Content-Type': 'application/json' })
        });
        const resText = await res.text();
        if (!res.ok) throw new Error(resText);
        commit('markAllAsRead', resText);
        return true;
      } catch (ex) {
        console.error(ex);
        return false;
      }
    }
  },
  getters: {
    unreadNotificationsCount: (state) => state.notifications.filter(n => n.isRead == false).length
  }
}
export default notificationStore;
